import { IMROverlayContainerController } from "./overlay-container.controller"

//#region Asset Imports

import './overlay-container.scss'
import * as TEMPLATE from './overlay-container.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrOverlayContainer'

export class IMROverlayContainerComponent implements ng.IComponentOptions {

    controller = [IMROverlayContainerController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE

    transclude = true

}
